module.exports = __webpack_public_path__ + "img/main-search-background-01.b3ed9c7b.jpg";